import React from 'react';

/**
 * Renders AI news sentiment as bold numerator + smaller "/10" denominator.
 * Inherits table/cell font size for the numerator.
 * @param {number|null|undefined} rating - Rating on 0–10 scale
 * @returns {React.ReactNode|null}
 */
export function renderNewsRating(rating) {
  if (rating === null || rating === undefined) return null;
  const raw = Number(rating);
  if (!Number.isFinite(raw)) return null;
  const numerator = Math.round(raw);
  return (
    <>
      <span className="news-rating-num">{numerator}</span>
      <span className="news-rating-denom">/10</span>
    </>
  );
}
